//// .Net generated code
export * from '@shared-models/data.enums';

//// BadgeComplianceGridCategoryEnum
export enum BadgeComplianceGridCategoryEnum {
    AllCategories= 0,
    PreHire= 1,
    Employee= 2,
    ThirdPartyContractor= 3,
    MemberFirm= 4,
    NonDeloitte= 5,
    FullTimeEmployee= 6,
    ContractorsOrInters= 7,
    BadgeExtension= 8,
    WorkPermit= 9
}

//// BadgeReasonEnum
export enum BadgeReasonEnum {
    BadgeDamaged= 1,
    BadgeLost= 2,
    BadgeStolen= 3,
    InitialBadgeRequest= 4,
    PhotoOnly= 5,
    PhotoCompliance= 6,
    BadgeExtension= 7,
    AccessOnly= 8
}

//// BadgeRequestCategoryEnum
export enum BadgeRequestCategoryEnum {
    PreHire= 1,
    Employee= 2,
    ThirdPartyContractor= 3,
    MemberFirm= 4,
    NonDeloitte= 5,
    FullTimeEmployee= 6,
    ContractorsOrInterns= 7,
    CleContractor= 8,
    MdfWorkPermit= 9,
    IdfWorkPermit= 10
}

//// BadgeStatusEnum
export enum BadgeStatusEnum {
    Pending= 1,
    Printing= 2,
    CreatedInTransfer= 3,
    ReadyToPickUp= 4,
    Provided= 5,
    ShippedTo= 7,
    Transfer= 8,
    Termed= 9,
    ApprovalNeeded= 10,
    ApprovedByManager= 11,
    DeclinedByManager= 12,
    DeclinedByBadgingOfficer= 13,
    ReadyForPrinting= 14,
    IrcApproved= 15,
    IrcDeclined= 16,
    ApprovedBySeniorManager= 17,
    DeclinedBySeniorManager= 18,
    LostInTransit= 19,
    Returned= 28,
    PendingPhotoCompliance= 20,
    PhotoCompliant= 21,
    BusinessApprovalNeeded= 22,
    DeclinedByBusinessApprover= 23,
    TIApprovalNeeded= 24,
    DeclinedByTIApprover= 25,
    Approved= 26,
    AccessProvided= 27
}

//// CleBadgeTypeEnum
export enum CleBadgeTypeEnum {
    New= 0,
    Extension= 1
}

//// PhotoStatusEnum
export enum PhotoStatusEnum {
    MissingNotProvided= 1,
    ApprovalPending= 2,
    FurtherReview= 3,
    Approved= 4,
    ResubmissionPending= 5,
    OfferRescindedRejected= 6,
    Cancelled= 7,
    NoActionRequired= 8,
    PhotoUploadPending= 9
}

//// RequestListGridCategoryEnum
export enum RequestListGridCategoryEnum {
    MyRequests= 0,
    VisitorRequests= 1,
    Contractors= 2,
    BadgeExtension= 3,
    CleContractors= 4
}

//// RoleCategoryEnum
export enum RoleCategoryEnum {
    PreHire= 1,
    Employee= 2,
    Contractor= 3
}

//// UserCountriesEnum
export enum UserCountriesEnum {
    UnitedStates= 1,
    India= 2,
    Mexico= 3,
    CostaRica= 4
}

//// UserRoleEnum
export enum UserRoleEnum {
    PreHire= 1,
    Csba= 2,
    FTE= 3,
    Employee= 4,
    FrontDesk= 5,
    Security= 6,
    Facilitator= 7,
    SeniorManager= 8,
    CTH= 9,
    EchoPartner= 10,
    IRCApprover= 11,
    ThirdPartyContractorApprover= 12,
    CLE= 13,
    BusinessApprover= 14,
    TIApprover= 15
}

//// VisitorType
export enum VisitorType {
    NonDeloitteVisitor= 0,
    MemberFirmVisitor= 1
}
